import './lib/no-eval';
import '@fontsource-variable/dm-sans';
import '@fontsource-variable/manrope';
import './styles.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { Api } from './lib/api';
import { CurentiaDevice } from './lib/device';
import { deviceLabel } from './lib/doors';
import { API_URL } from './lib/env';
import { LocalStore } from './lib/store';

const api = new Api(API_URL);
const device = new CurentiaDevice(api, () => LocalStore.open(), { label: deviceLabel(navigator.userAgent) });
void device.init();

const root = document.getElementById('root');
if (!root) throw new Error('The page has no root element');
createRoot(root).render(
  <StrictMode>
    <App device={device} />
  </StrictMode>,
);
